import './rule_list_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.TicketRuleListView extends Monitoring.Views.RuleListView
  template: JST["backbone/templates/monitoring/rules/ticket_rule_list"]

  initialize: (@options = {}) ->
    @rules                = @options.rules
    @availableTopics      = @options.availableTopics
    @availableTags        = @options.availableTags
    @availableGroups      = @options.availableGroups
    @availableSubtypes    = @options.availableSubtypes
    @availableTags        = @options.availableTags
    @availableUserGroups   = @options.availableUserGroups
    @availableOperators   = @options.availableOperators
    @availableUserProfileTags = @options.availableUserProfileTags
    @availableTemplates = @options.availableTemplates
    @currentUser          = @options.currentUser
    @availableSentiments  = @options.availableSentiments
    @availableModerationDecision = @options.availableModerationDecision

  getTicketPreviousStatusString: (conditions) ->
    @getTicketStatusString(conditions, "previous_ticket_status")

  getTicketPresentStatusString: (conditions) ->
    @getTicketStatusString(conditions, "present_ticket_status")

  getTicketStatusString: (conditions, key) ->
    if conditions[key].length > 0
      status = conditions[key]
      "#{I18n.t('monitoring.rules.fields.' + key)}: #{status.join(', ')}"
    else
      ""

  getAssignedToGroupString: (conditions) ->
    @getAssignedConditionString(conditions, 'assigned_to_user_group')

  getAssignedToOperatorString: (conditions) ->
    @getAssignedConditionString(conditions, 'assigned_to_operator') + @getOperatorNameString(conditions)

  getAssignedConditionString: (conditions, key) ->
    if conditions[key].length > 0
      condition = conditions[key].replace(/-/g, '_')
      assignedString = I18n.t("monitoring.rules.#{condition}")
      "#{I18n.t('monitoring.rules.fields.' + key)}: #{assignedString}"
    else
      ""

  getOperatorNameString: (conditions) ->
    operatorID = conditions['operator_id']
    if operatorID.length > 0
      foundOperator = _.find(@availableOperators, (operator) => operator.code.toString() == operatorID)
      if foundOperator
        " (#{foundOperator.description})"
      else
        ''
    else
      ''

  getNewTicketString: (conditions) ->
    if conditions.new_ticket.length > 0
      condition = conditions.new_ticket.replace(/-/g, '_') + '_ticket'
      condString = I18n.t("monitoring.rules.#{condition}")
      "#{I18n.t('monitoring.rules.fields.new_ticket')}: #{condString}"
    else
      ""

  getTicketConditionsAsText: (rule) ->
    ticket_conditions = rule.get('ticket_condition')
    _.filter([
      @includedTagsStringFor(ticket_conditions),
      @excludedTagsStringFor(ticket_conditions),
      @includedGroupsStringFor(ticket_conditions),
      @excludedGroupsStringFor(ticket_conditions),
      @getTicketPreviousStatusString(ticket_conditions),
      @getTicketPresentStatusString(ticket_conditions),
      @getAssignedToGroupString(ticket_conditions),
      @getAssignedToOperatorString(ticket_conditions),
      @getNewTicketString(ticket_conditions)
    ], (str) -> str != "").join('<br>')

  getActionsAsText: (rule) ->
    ticket_actions = rule.get('actions')
    _.filter([
      @getUnassignAllString(ticket_actions),
      @getUnassignOperatorString(ticket_actions),
      @getAssignActionString(ticket_actions),
      @getCloseTicketActionString(ticket_actions),
      @getPrioritizeTicketActionString(ticket_actions),
      @getReplyTicketActionString(ticket_actions)
    ], (str) -> str != "").join('<br>')

  getUnassignAllString: (actions) ->
    if actions.unassign_all_in_ticket_action
      I18n.t('monitoring.rules.actions.unassign_all.prefix')
    else
      ''

  getUnassignOperatorString: (actions) ->
    if actions.unassign_operator_in_ticket_action
      I18n.t('monitoring.rules.actions.unassign_operator.prefix')
    else
      ''

  getAssignActionString: (actions) ->
    if actions.assign_ticket_to_users_group_action.length > 0
      @getAssignUserGroupString(actions)
    else if actions.assign_ticket_to_operator_action.length > 0
      @getAssignOperatorString(actions)
    else
      ""

  getAssignUserGroupString: (actions) ->
    userGroupId = actions.assign_ticket_to_users_group_action
    userGroup = _.find(@availableUserGroups, (userGroup) -> userGroup.code.toString() == userGroupId)
    if userGroup
      "#{I18n.t('monitoring.rules.actions.assign_to_user_group.prefix')}: #{userGroup.description}"
    else
      ''

  getAssignOperatorString: (actions) ->
    operatorId = actions.assign_ticket_to_operator_action
    operator = _.find(@availableOperators, (operator) -> operator.code.toString() == operatorId)
    if operator
      "#{I18n.t('monitoring.rules.actions.assign_to_operator.prefix')} #{operator.description}"
    else
      ''

  getPrioritizeTicketActionString: (actions) ->
    priority = actions.prioritize_ticket_action
    if priority
      "#{I18n.t('monitoring.rules.actions.prioritize_ticket.prefix')}: #{priority}"
    else
      ''

  getCloseTicketActionString: (actions) ->
    if actions.close_ticket_action.length > 0
      I18n.t('monitoring.rules.actions.close_ticket.label')
    else
      ''

  getReplyTicketActionString: (actions) ->
    if actions.reply_predefined_template_id.length > 0
      replyChannelString = I18n.t("monitoring.rules.actions.reply_ticket.reply_channel.#{actions.reply_channel}").toLowerCase()
      "#{I18n.t('monitoring.rules.actions.reply_ticket.prefix')} (#{replyChannelString})"
    else
      ''

  actionDescription: (action_type, descr) ->
    prefix = I18n.t("monitoring.rules.actions.#{action_type}.prefix")
    suffix = I18n.t("monitoring.rules.actions.#{action_type}.suffix")
    "#{prefix} '#{descr}' #{suffix}"

